import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useCustomerType } from "@faire/help-center-utils/hooks/useCustomerType";

import { ISearchResult } from "../RoundSearchInput";

export const useInitialSuggestedSearchResult = (): ISearchResult[] => {
  const articles = useArticles();
  const { customerType } = useCustomerType();

  if (customerType === CustomerTypes.RETAILER) {
    return [
      articles.MyOrders.HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT,
      articles.PaymentsAndInvoices.NET_60_TERMS,
      articles.MyOrders.CONTACT_A_BRAND,
    ].map((article) => ({ id: article.id, title: article.name }));
  } else {
    return [
      articles.FulfillingOrders.UNDERSTAND_ORDER_STATUS,
      articles.MyOrders.HOW_AM_I_NOTIFIED_NEW_ORDERS,
      articles.FulfillingOrders.ACCEPTING_ORDER,
    ].map((article) => ({ id: article.id, title: article.name }));
  }
};
